export function module_common() {

	$(function() {
		commonContents();
		
		var timer = false;
		var count = 0;
		var winWidth = $(window).width();
		var winHeight = $(window).height();
		var winWidth_resized;
		var winHeight_resized;

		//--------------------------------------------------------
		// Resize Event
		//--------------------------------------------------------
		$(window).on('resize', function() {
			// リサイズ後の放置時間が指定ミリ秒以下なら何もしない(リサイズ中に何度も処理が行われるのを防ぐ)
			if (timer !== false) {
				clearTimeout(timer);
			}

			// 放置時間が指定ミリ秒以上なので処理を実行
			timer = setTimeout(function() {
				// リサイズ後のウインドウの横幅・高さを取得
				winWidth_resized = $(window).width();
				winHeight_resized = $(window).height();

				// リサイズ前のウインドウ幅・髙さとリサイズ後のウインドウ幅・髙さが異なる場合
				if ( winWidth != winWidth_resized || winHeight != winHeight_resized ) {
					commonContents();

					// 次回以降使えるようにリサイズ後の幅・髙さをウインドウ幅に設定する
					winWidth = $(window).width();
					winHeight = $(window).height();
				}
			}, 200);
		});

		//リサイズ用関数
		function commonContents() {
			//timerをクリア、countをリセット
			clearTimeout(timer);
			count = 0;
			
			//ヘッダーロゴの src取得
			var logoSrc = $('.h-logo-pc').children('img').attr('src');
			
			function logoBlue() {
				var src = logoSrc.replace('logo-pc-white.svg', 'logo-pc.svg');
				$('.h-logo-pc').children('img').attr('src', src);
			}
			
			function logoWhite() {
				var src = logoSrc.replace('logo-pc.svg', 'logo-pc-white.svg');
				$('.h-logo-pc').children('img').attr('src', src);
			}
			
			if(window.innerWidth >= 1044) {
				logoWhite();
				if($('#header').hasClass('headerfix')) {
					logoBlue();
				}
			} else {
				logoBlue();
				$(window).on('load scroll', function () {
					logoBlue();
				});
			}

			//Pagetop & Header Class
			var topBtn = $('.pagetop');	
			topBtn.hide();

			$(window).on('scroll', function () {
				if ($(this).scrollTop() > 160) {
					topBtn.fadeIn();
				} else {
					topBtn.fadeOut();
				}

				if ($(this).scrollTop() > 260) {
					$('#header, .spHeader').addClass('headerfix');
					logoBlue();
				} else {
					$('#header, .spHeader').removeClass('headerfix');
					if(window.innerWidth >= 1044) {
						logoWhite();
					} else {
						logoBlue();
					}
				}
			});

			//スクロールしてトップ
			topBtn.click(function () {
				$('body,html').animate({
					scrollTop: 0
				}, 800,'swing');
				return false;
			});
		}
	});
}